<template>

  <ul>
    <li v-if="showDebug">
      <div
        v-for="(item, key) in viewColumn"
        :key="key"
      >
        <span style="font-weight: 500">{{ key }}:</span> {{ item }}
      </div>
    </li>
    <!--SORT UP-->
    <li @click="tableStore.setSorting({ columnName: viewColumn.field,  order: 'ASC' })">
      <font-awesome-icon :icon="['fal', 'arrow-down-a-z']" class="menuitem-icon" />
      <span>Sorter stigende</span>
    </li>
    <!--SORT DOWN-->
    <li @click="tableStore.setSorting({ columnName: viewColumn.field,  order: 'DESC' })">
      <font-awesome-icon :icon="['fal', 'arrow-down-z-a']" class="menuitem-icon" />
      <span>Sorter synkende</span>
    </li>
    <li class="separator" />
    <!--INPUT-->
    <li>
      <BaseInput
        v-model="inputValue"
        :class="validateInput"
        type="text"
        placeholder="Skriv filter..."
        @blur="addInput"
        @keyup.enter="addInput"
        @keyup.tab="addInput"
      />
      <span
        v-if="validateInput && viewColumn.basicDataType === 'nvarchar'"
        class="error-message"
      >Feil</span>
      <span
        v-if="validateInput && viewColumn.basicDataType === 'int'"
        class="error-message"
      >Kun heltall</span>
      <span
        v-if="validateInput && viewColumn.basicDataType === 'bigint'"
        class="error-message"
      >Kun heltall</span>
      <span
        v-if="validateInput && viewColumn.basicDataType === 'date'"
        class="error-message"
      >Feil dato</span>
      <span
        v-if="validateInput && (viewColumn.basicDataType === 'datetime' || viewColumn.basicDataType === 'datetime2')"
        class="error-message"
      >Feil
        dato/tid</span>
    </li>
    <!--LIST OF FILTERS-->
    <li
      v-for="(filter, idx) in tableStore.getFilter(viewColumn.field)"
      :key="idx"
      class="p-menuitem-link"
      style="padding-left: 40px; width: 100%"
    >
      <span
        v-if="filter.icon"
        style="width: 100%"
      >
        <font-awesome-icon :icon="filter.icon" />
        <span
          class="filter-item ml-2"
          style=""
        >
          {{ filter.value }}
        </span>
      </span>
      <span
        v-else
        class="p-menuitem-text"
      >
        {{ filter.operator }}
      </span>
      <font-awesome-icon
        :icon="['fal', 'times']"
        style="margin-right: 1rem; margin-left: 6px"
        @click.stop="tableStore.removeFilter(viewColumn.field, filter.operator, filter.value)"
      />
    </li>
    <!--REMOVE FILTERS-->
    <li @click="tableStore.clearFilter(viewColumn.field)">
      <font-awesome-icon :icon="['fal', 'filter-slash']" class="menuitem-icon remove" />
      <span>Fjern alle filter</span>
    </li>
    <li class="separator" />
    <!--FILTER NULL-->
    <li @click="tableStore.addFilterNull(viewColumn.field)">
      <span style="padding-left: 28px">Filter <strong>p&aring;</strong> blanke</span>
    </li>
    <!--FILTER NOT NULL-->
    <li @click="tableStore.addFilterNotNull(viewColumn.field)">
      <span style="padding-left: 28px">Filter <strong>bort</strong> blanke</span>
    </li>
    <li class="separator" />
    <!--REFRESH-->
    <li @click="() => { tableStore.refreshQuery(); $emit('close') }">
      <font-awesome-icon :icon="['fal', 'play']" class="menuitem-icon play" />
      <span>Oppdater</span>
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useTableStore } from '@/store/storeTable'
import { useGlobalStore } from '@/store/storeGlobal'
import BaseInput from '@/components/BaseComponents/BaseInput.vue'

// GlobalStore
const globalStore = useGlobalStore()
const { showDebug } = storeToRefs(globalStore)

const tableStore = useTableStore()
const inputValue = ref('')

const props = defineProps({
  viewColumn: { type: Object, required: true }
})


function addInput () {
  if (!inputValue.value) return

  const inputItem = tableStore.parseQueryOperator(inputValue.value, props.viewColumn.field)
  tableStore.addFilter(inputItem)
  inputValue.value = ''
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-inline-start: 0;
  margin: 0;
}

li {
  cursor: pointer;
  padding: 12px;
}

li:hover {
  background-color: rgb(241, 241, 241);
}

.separator {
  border-top: 1px solid silver;
  padding: 0;
}

.menuitem-icon {
  margin-right: 12px;
}

.play {
  color: #689f38;
}

.remove {
  color: #d32f2f;
}

.filter-item {
  display: inline-block;
  width: 11.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.error-message {
  color: #d32f2f;
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
}
</style>
